<template>
    <div>
        <b-card no-body>
            <b-tabs card>
                <b-tab title="Generales" active>
                    <app-general-indicators />
                </b-tab>
                <b-tab title="Por Cliente">
                    <app-client-indicators />
                </b-tab>
                <b-tab title="Por Usuario">
                    <app-user-indicators />
                </b-tab>
                <b-tab title="Pareto Clientes">
                    <app-pareto-clients />
                </b-tab>
                <b-tab title="PQRs Dinámico">
                    <!-- <iframe width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=4a8edf7d-97ae-4d71-9d16-01a70fea6808&autoAuth=true&ctid=791c516b-fadf-47d1-a695-2a2e869f888d" frameborder="0" allowFullScreen="true"></iframe> -->
                    <app-complete-report></app-complete-report>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import appGeneralIndicators from './GeneralIndicators/GeneralIndicators'
import appClientIndicators from './ClientIndicators/ClientIndicators'
import appUserIndicators from './UserIndicators/UserIndicators'
import appParetoClients from './ParetoClients/ParetoClients'
import appCompleteReport from './CompleteReport/CompleteReport'
export default {
    name: 'pqrs_indicators',
    components: {
        appGeneralIndicators,
        appClientIndicators,
        appUserIndicators,
        appParetoClients,
        appCompleteReport,
    },
}
</script>
